import React, { useEffect, useState } from "react";
import { useAuthToken } from "./AuthProvider";
import { AppState } from "./store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "./img/enjuggernaut_logo.png";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import useWindowDimensions from "./Account/WindowDimensions";
import arrow_back from "./img/arrow_back_gray.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function Forgot() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");

  async function submitLogin() {
    const apiEndpoint =  "/api/forgot";

    const formData = new FormData();

    formData.append("email", email);

    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const responseData = await response.json();

      if (response.ok) {
        toast.success("Password reset email sent.");
        navigate("/");
      } else {
        toast.error(responseData.error);
      }
    } catch (error) {
      toast.error("Error logging in!");
      console.log(error);
    }
  }

  return (
    <div className="light-panel fixed min-h-screen w-full">
      <button
        className="fixed ml-4 mt-4"
        onClick={() => {
          navigate("/");
        }}
      >
        <img src={arrow_back} />
      </button>

      <div className="mx-auto mt-36 w-4/5 rounded-md bg-[#252526] shadow-[0_10px_100px_-2px_rgba(0,0,0,0.3)] md:w-1/2 lg:w-1/2 xl:w-1/3">
        <div className="flex flex-col rounded-md p-4 lg:p-6 xl:p-8 2xl:p-10">
          <img className="mx-auto w-4/5" alt="enjuggernaut logo" src={logo} />

          <h1 className="pt-2 font-code text-lg font-bold text-[#CCCCC1] lg:text-xl xl:pt-4 xl:text-2xl 2xl:pt-8">
            Email
          </h1>
          <input
            className="mt-2 w-full p-2 font-code text-base lg:text-lg xl:text-xl 2xl:p-4"
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              setEmail(event.currentTarget.value)
            }
          />

          <button
            className="login-button mx-auto mt-2 w-1/2 p-3 font-code text-lg font-bold md:text-xl lg:text-2xl xl:mt-6 xl:text-3xl 2xl:mt-12 2xl:text-4xl"
            onClick={() => submitLogin()}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}
